import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  RequestLevelingDto,
  RequestOnBoardingGoalsDto,
} from '../models/onboarding.model';

type OnBoardingStep = {
  nextStepButtonLabel: string;
  step: string;
};

interface OnboardingState {
  steps: OnBoardingStep[];
  currentStep: OnBoardingStep;
  setCurrentStep: (step: OnBoardingStep) => void;

  isLevelingModalOpen: boolean;
  setIsLevelingModalOpen: (isOpen: boolean) => void;

  levelingModalTitle: string;
  setLevelingModalTitle: (title: string) => void;

  levelingModalSubtitle: string;
  setLevelingModalSubtitle: (subtitle: string) => void;

  levelingData: RequestLevelingDto | null;
  setLevelingData: (data: RequestLevelingDto) => void;

  ProfileAndGoalsData: RequestOnBoardingGoalsDto | null;
  setProfileAndGoalsData: (data: RequestOnBoardingGoalsDto) => void;

  currentCourses: any[];
  setCurrentCourses: (courses: any[]) => void;

  diagnosisSelectedQuestions: Record<string, string>;
  setDiagnosisSelectedQuestions: (questions: Record<string, string>) => void;
  updateDiagnosisSelectedQuestion: (questionId: string, alternativeId: string) => void;

  resetOnboarding: () => void;
}

const steps = [
  {
    step: 'Welcome',
    nextStepButtonLabel: 'Ir para Perguntas de perfil e diagnóstico',
  },
  {
    step: 'ProfileAndGoals',
    nextStepButtonLabel: 'Continuar',
  },
  {
    step: 'SimulatedDiagnosis',
    nextStepButtonLabel: 'Iniciar diagnóstico',
  },
  {
    step: 'LevelingResult',
    nextStepButtonLabel: 'Finalizar diagnóstico',
  },
];

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      steps,
      currentStep: steps[0],
      setCurrentStep: (step) => set({ currentStep: step }),

      isLevelingModalOpen: true,
      setIsLevelingModalOpen: (isOpen) => set({ isLevelingModalOpen: isOpen }),

      levelingModalTitle: '',
      setLevelingModalTitle: (title) => set({ levelingModalTitle: title }),

      levelingModalSubtitle: '',
      setLevelingModalSubtitle: (subtitle) =>
        set({ levelingModalSubtitle: subtitle }),

      levelingData: null,
      setLevelingData: (data) => set({ levelingData: data }),

      ProfileAndGoalsData: null,
      setProfileAndGoalsData: (data) => set({ ProfileAndGoalsData: data }),

      currentCourses: [],
      setCurrentCourses: (courses) => set({ currentCourses: courses }),

      diagnosisSelectedQuestions: {},
      setDiagnosisSelectedQuestions: (questions) =>
        set({ diagnosisSelectedQuestions: questions }),
      updateDiagnosisSelectedQuestion: (questionId, alternativeId) =>
        set((state) => ({
          diagnosisSelectedQuestions: {
            ...state.diagnosisSelectedQuestions,
            [questionId]: alternativeId,
          },
        })),

      resetOnboarding: () =>
        set({
          steps,
          currentStep: steps[0],
          isLevelingModalOpen: true,
          levelingModalTitle: '',
          levelingModalSubtitle: '',
          levelingData: null,
          ProfileAndGoalsData: null,
          currentCourses: [],
          diagnosisSelectedQuestions: {},
        }),
    }),
    {
      name: 'onboarding-diagnosis-storage',
      partialize: (state) => ({
        diagnosisSelectedQuestions: state.diagnosisSelectedQuestions,
      }),
    }
  )
);
